import { Component, OnInit } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { AuthService, InputType, KeyValuePair, MemberQuery, OutputField, ProviderName } from "@fgb/core";

import { tap } from "rxjs";

@Component({
    selector: 'fgb-endurance-zone-user-login',
    templateUrl: './endurance-zone-user-login.component.html',
    styleUrls: ['./endurance-zone-user-login.component.scss'],
  })
  export class EnduranceZoneUserLoginComponent implements OnInit {

    safeUrl: SafeResourceUrl;
  
    constructor(
      private authService: AuthService,
      private memberQuery: MemberQuery,
      private domSanitizer: DomSanitizer
    ) {}
    
    ngOnInit() {
        this.logoffEnduranceZoneIframe()
    }
  
    logoffEnduranceZoneIframe() {
      let user = this.memberQuery.getUserContext();

      let options: KeyValuePair[] = [{key: "MemberId", value: user.memberId}]
      this.authService.loginThirdPartyObservable(ProviderName.EnduranceZone, 1, options).pipe(tap((data) => {
        let outputs = data as OutputField[];
        const hasUrl = outputs.find((x) => x.InputType == InputType.Url);
        if(hasUrl){
            this.safeUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(hasUrl.Value);
        }
      })).toPromise();
    }
  }